const refs = 'pages'
export default [
    { 
        path: '/page/:slug', 
        name: 'page', 
        component: () => import('@/views/'+refs+'/List.vue')
    },
    { 
        path: '/termsconditions', 
        name: 'termsconditions', 
        component: () => import('@/views/'+refs+'/termsConditions.vue')
    },
    { 
        path: '/privacypolicy', 
        name: 'privacypolicy', 
        component: () => import('@/views/'+refs+'/privacyPolicy.vue')
    }
]
